module.exports = __webpack_public_path__ + "img/fees.weekly.823eb67c.png";